import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/Input';
import { FIELD_NAMES } from './BillingAddress.schema';
import { billingAddress as TEXT } from 'locales/en/cart';
import CountrySelect from 'components/CountrySelect';

export const NonFundraiserBillingAddress = ({
  control,
  register,
  errors,
  form
}) => {
  return (
    <>
      <Input
        label={TEXT.company_name}
        name={FIELD_NAMES.billing_name}
        register={register}
        required
        error={errors[FIELD_NAMES.billing_name]?.message}
      />
      <Input
        label={TEXT.address}
        name={FIELD_NAMES.billing_address_1}
        register={register}
        required
        error={errors[FIELD_NAMES.billing_address_1]?.message}
        maxLength={40}
      />
      <Input
        name={FIELD_NAMES.billing_address_2}
        register={register}
        className="mt-1"
        error={errors.billing_address_2?.message}
        maxLength={40}
      />
      <div className="grid lg:grid-cols-2 gap-x-4 lg:gap-x-4">
        <Input
          label={TEXT.postcode}
          name={FIELD_NAMES.billing_postcode}
          register={register}
          required
          error={errors[FIELD_NAMES.billing_postcode]?.message}
        />
        <CountrySelect
          name={FIELD_NAMES.billing_country}
          label={TEXT.country}
          control={control}
          required
          error={errors[FIELD_NAMES.billing_country]?.name?.message}
        />
        <Input
          name={FIELD_NAMES.billing_city}
          label={TEXT.city}
          register={register}
          required
          error={errors[FIELD_NAMES.billing_city]?.message}
        />
        <Input
          name={FIELD_NAMES.billing_state}
          label={TEXT.state}
          register={register}
          required
          error={errors[FIELD_NAMES.billing_state]?.message}
        />
      </div>
    </>
  )
}

NonFundraiserBillingAddress.propTypes = {
  control: PropTypes.object,
  register: PropTypes.func,
  errors: PropTypes.object,
  form: PropTypes.object
}
